export default __webpack_public_path__ + "src/assets/Trezor_Desktop.cae2782000df359b638758b9855fed76.svg";